function normalizeWorkspaceName(workspaceName: string): string {
  return workspaceName
    .split(/\s+/)
    .filter(function isNotEmpty(wordPart) {
      return wordPart.length > 0;
    })
    .join(' ')
    .toLowerCase();
}

export function doesWorkspaceNameMatch(typedName: string, workspaceName: string): boolean {
  const normalizedTypedName = normalizeWorkspaceName(typedName);
  return (
    normalizedTypedName.length > 0 && normalizedTypedName === normalizeWorkspaceName(workspaceName)
  );
}
